import { baseRequest } from './index'
import humps from 'humps'

export const DESKTOP_PREFERENCES_REQUEST = 'DESKTOP_PREFERENCES_REQUEST'
export const DESKTOP_PREFERENCES_SUCCESS = 'DESKTOP_PREFERENCES_SUCCESS'
export const DESKTOP_PREFERENCES_FAILURE = 'DESKTOP_PREFERENCES_FAILURE'

export function loadDesktopPreferences () {
  return baseRequest({
    url: '/desktop_preferences',
    method: 'GET',
    actions: [ DESKTOP_PREFERENCES_REQUEST, DESKTOP_PREFERENCES_SUCCESS, DESKTOP_PREFERENCES_FAILURE ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const MOBILE_PREFERENCES_REQUEST = 'MOBILE_PREFERENCES_REQUEST'
export const MOBILE_PREFERENCES_SUCCESS = 'MOBILE_PREFERENCES_SUCCESS'
export const MOBILE_PREFERENCES_FAILURE = 'MOBILE_PREFERENCES_FAILURE'

export function loadMobilePreferences () {
  return baseRequest({
    url: '/mobile_preferences',
    method: 'GET',
    actions: [ MOBILE_PREFERENCES_REQUEST, MOBILE_PREFERENCES_SUCCESS, MOBILE_PREFERENCES_FAILURE ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const EMAIL_PREFERENCES_REQUEST = 'EMAIL_PREFERENCES_REQUEST'
export const EMAIL_PREFERENCES_SUCCESS = 'EMAIL_PREFERENCES_SUCCESS'
export const EMAIL_PREFERENCES_FAILURE = 'EMAIL_PREFERENCES_FAILURE'

export function loadEmailPreferences () {
  return baseRequest({
    url: '/email_preferences',
    method: 'GET',
    actions: [ EMAIL_PREFERENCES_REQUEST, EMAIL_PREFERENCES_SUCCESS, EMAIL_PREFERENCES_FAILURE ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const UPDATE_EMAIL_PREFERENCES_REQUEST = 'UPDATE_EMAIL_PREFERENCES_REQUEST'
export const UPDATE_EMAIL_PREFERENCES_SUCCESS = 'UPDATE_EMAIL_PREFERENCES_SUCCESS'
export const UPDATE_EMAIL_PREFERENCES_FAILURE = 'UPDATE_EMAIL_PREFERENCES_FAILURE'

export function updateEmailPreferences (data) {
  return baseRequest({
    url: '/email_preferences',
    method: 'PATCH',
    body: {
      preference: {
        ...data
      }
    },
    actions: [
      UPDATE_EMAIL_PREFERENCES_REQUEST,
      UPDATE_EMAIL_PREFERENCES_SUCCESS,
      UPDATE_EMAIL_PREFERENCES_FAILURE
    ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const UPDATE_DESKTOP_PREFERENCES_REQUEST = 'UPDATE_DESKTOP_PREFERENCES_REQUEST'
export const UPDATE_DESKTOP_PREFERENCES_SUCCESS = 'UPDATE_DESKTOP_PREFERENCES_SUCCESS'
export const UPDATE_DESKTOP_PREFERENCES_FAILURE = 'UPDATE_DESKTOP_PREFERENCES_FAILURE'

export function updateDesktopPreferences (data) {
  return baseRequest({
    url: '/desktop_preferences',
    method: 'PATCH',
    body: {
      preference: {
        ...data
      }
    },
    actions: [
      UPDATE_DESKTOP_PREFERENCES_REQUEST,
      UPDATE_DESKTOP_PREFERENCES_SUCCESS,
      UPDATE_DESKTOP_PREFERENCES_FAILURE
    ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const UPDATE_MOBILE_PREFERENCES_REQUEST = 'UPDATE_MOBILE_PREFERENCES_REQUEST'
export const UPDATE_MOBILE_PREFERENCES_SUCCESS = 'UPDATE_MOBILE_PREFERENCES_SUCCESS'
export const UPDATE_MOBILE_PREFERENCES_FAILURE = 'UPDATE_MOBILE_PREFERENCES_FAILURE'

export function updateMobilePreferences (data) {
  return baseRequest({
    url: '/mobile_preferences',
    method: 'PATCH',
    body: {
      preference: {
        ...data
      }
    },
    actions: [
      UPDATE_MOBILE_PREFERENCES_REQUEST,
      UPDATE_MOBILE_PREFERENCES_SUCCESS,
      UPDATE_MOBILE_PREFERENCES_FAILURE
    ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST = 'SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST'
export const SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS = 'SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS'
export const SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE = 'SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE'

export function loadSubLocationNotificationPreferences () {
  return baseRequest({
    url: '/users/sub_locations',
    method: 'GET',
    actions: [
      SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST,
      SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS,
      SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE
    ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST = 'UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST'
export const UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS = 'UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS'
export const UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE = 'UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE'

export function updateSubLocationNotificationPreferences(data) {
  return baseRequest({
    url: '/users/sub_locations',
    method: 'PATCH',
    body: {
      user: {
        ...data
      }
    },
    actions: [
      UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_REQUEST,
      UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_SUCCESS,
      UPDATE_SUB_LOCATION_NOTIFICATION_PREFERENCES_FAILURE
    ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}



// WEBPACK FOOTER //
// ./src/actions/settings.js